(function() {
    /* jshint validthis: true */
    "use strict";

    var lang = lang || document.documentElement.lang;
    var rafThres = 60;
    var scrollY = 0;
    var scrollYbefore = 0;
    
    var body;
    var headBar;
    
    function animateHeader() {
        if (rafThres > 0) {
            scrollY = window.scrollY;
            if (scrollY > scrollYbefore) {
                addClass(body, "scroll-down");
                removeClass(body, "scroll-up");
                if (scrollY < headBar.clientHeight) {
                    addClass(headBar, "hold-position");
                } else {
                    removeClass(headBar, "hold-position");
                }
            } else if (scrollY < scrollYbefore) {
                removeClass(body, "scroll-down");
                addClass(body, "scroll-up");
            }
            scrollYbefore = scrollY;
            rafThres--;
        }
        rAF(animateHeader);
    }
    
    function toggleMenu(e) {
        toggleClass(getAncestor(e.target, "header"), "menu-open");
    }
    function closeMenu(e) {
        removeClass(getAncestor(e.target, "header"), "menu-open");
    }
    
    function mobileOpenSubmenu(e) {
        var btn = e.currentTarget || this;
        var targ = qs(".mobile-submenu-" + btn.getAttribute("data-open-id"));
        
        if (targ) {
            e.preventDefault();
            addClass(targ, "open");
            addClass(getAncestor(btn, "mobile-menu-wrap"), "open");
        }
    }
    function mobileCloseSubmenu(e) {
        removeClassAll(qsa(".mobile-menu-wrap"), "open");
    }
    
    window.addEventListener("scroll", function() {
        rafThres = 60;
    });

    // Pre-initiate
    DOMInit("interactive", function(e) {
        body = document.body || qs("body");
        headBar = qs(".head-bar");
        if (headBar) rAF(animateHeader);
        
        // Event open and close the responsive menu
        bindEvent(".mobile-menu-btn", "click", toggleMenu);
        bindEvent(".header-mobile-overlay", "click", closeMenu);
        // Event sub navigation
        bindEvent(".mobile-menu-wrap.level-0 .header-nav-item", "click", mobileOpenSubmenu);
        bindEvent(".mobile-menu-nav-back", "click", mobileCloseSubmenu);
    });
    
    // Initiate
    DOMInit("complete", function(e) {
        
    });

})();